var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('title-entities',{attrs:{"title":"Serviços"}}),_c('v-container',{attrs:{"fluid":""}},[_c('v-card',{staticClass:"disable-scrollbars mt-n3",attrs:{"flat":""}},[_c('entidades')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }